import { set } from 'date-fns';
import { format } from 'date-fns-tz';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import { IconButton, SIZE } from '~/components/isolated/IconButton';
// TODO: check import correctness
import Modal from '~/components/Modal/Modal';
import { useDateLang } from '~/hooks/useDateLang';
import { useModal } from '~/hooks/useModal';
import { useTimeFormat } from '~/hooks/useTimeFormat';

import { orderStore } from '~/stores';

import styles from './ModalDeliveryInfoCDV3.module.scss';

const ModalDeliveryInfoCDV3 = observer(() => {
  const { closeModal } = useModal();
  const { t } = useTranslation();
  const { locale } = useDateLang();
  const { timeFormat } = useTimeFormat();

  const { expressDelivery } = orderStore;

  const parseTime = (type: 'opening' | 'closing', time?: string) => {
    if (!time) {
      if (type === 'closing') {
        return '00:00';
      }
      return '11:00';
    }

    const [hours, minutes] = time.split(':');

    const result = format(
      set(Date.now(), { hours: +hours!, minutes: +minutes! }),
      timeFormat,
      {
        timeZone: company.config.timeZone,
        locale,
      },
    );

    if (result === '23:59') {
      return t('midnight');
    }

    return result;
  };
  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <Modal
      isShow
      className={styles.deliveryTerms}
      onBackdropDismiss={handleCloseModal}
    >
      <div className={styles.deliveryTerms}>
        <header className={styles.deliveryTerms__header}>
          <h2>{t('deliveryTerms')}</h2>
          <IconButton
            size={SIZE.S}
            variant="outline"
            icon="close"
            onClick={handleCloseModal}
          />
        </header>
        <div className={styles.deliveryTerms__body}>
          <div className={styles.section}>
            <p>
              {t('deliveryOffers')} <strong>{t('speed')}</strong> {t('or')}{' '}
              <strong>{t('schedule')}</strong>.
            </p>
            <h4>
              {t('expressDelivery')} (60-90{t('min')})
            </h4>
            <p>
              {t('whenTimeMatters')} <strong>{t('fastestDelivery')}.</strong>
            </p>
            <ul>
              <li>{t('expressPriorityHandling')}</li>
              <li>{t('expressRealTimeTracking')}</li>
              <li>{t('expressEtaShown')}</li>
            </ul>
            <p>
              <strong>
                {t('expressDeliveryAvailability', {
                  from: parseTime('opening', expressDelivery?.opening),
                  to: parseTime('closing', expressDelivery?.closing),
                })}
              </strong>
            </p>
          </div>

          <div className={styles.section}>
            <h4>{t('standardSameDayScheduledDelivery')}</h4>
            <p>
              {t('standardChooseDateTimeSlotPrefix')}
              <strong>{t('standardChooseDateTimeSlotBold')}</strong>
              {t('standardChooseDateTimeSlotSuffix')}
            </p>
            <ul>
              <li>
                {t('standardOrderAnytime')} ({t('acceptedLow')}{' '}
                <strong>24/7</strong>)
              </li>
              <li>{t('standardSelectPreferredSlot')}</li>
            </ul>
          </div>

          <div className={styles.section}>
            <h4>{t('idVerificationTitle')}</h4>
            <p>
              {t('idVerificationDescriptionPrefix')}
              <strong>{t('idVerificationDescriptionBold')}</strong>
              {t('idVerificationDescriptionSuffix')}
            </p>
          </div>

          <div className={styles.section}>
            <h4>{t('deliveryPaymentTerms')}</h4>
            <p>
              {t('deliveryFeeVaryPrefix')}
              <strong>{t('deliveryFeeVaryBold')}</strong>
              {t('deliveryFeeVarySuffix')}
              <br />
              {t('exactFeePrefix')}
              <strong>{t('exactFeeBold')}</strong>
              {t('exactFeeSuffix')}
            </p>
          </div>

          <div className={styles.section}>
            <h4>{t('charityTitle')}</h4>
            <p>
              <strong>{t('goToCharity')}</strong> {t('donatedToCharity')}
            </p>
          </div>
        </div>
        <footer className={styles.deliveryTerms__footer}>
          <Button
            variant="primary"
            size="XL"
            onClick={handleCloseModal}
            className={styles.confirmButton}
          >
            {t('okButton')}
          </Button>
        </footer>
      </div>
    </Modal>
  );
});

export default ModalDeliveryInfoCDV3;
